export default __webpack_public_path__ + "static/media/mainBgMomMobile.64a5a26a.png";